<template>
    <div id="liquor">
        <a-drawer
                :maskClosable="false"
                class="liquorDrawerLeft"
                :title="drawerTitle"
                placement="left"
                :visible="visible"
                width="1184"
                @close="closeDrawer"
        >
            <a-row type="flex" justify="start" class="headerSteps"  align="middle">

                <a-col class="sbxs" :class='[isview=="step1" ? "stepsAvtiveBorder" : ""]' @click="menuGoType('step1')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-inv.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Select</a-row>
                            <a-row class="headerStepsTitle">Inventory</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs"  :class='[isview=="step2" ? "stepsAvtiveBorder" : ""]' @click="menuGoType('step2')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-ord.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Order</a-row>
                            <a-row class="headerStepsTitle">Detail</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs"  :class='[isview=="step3" ? "stepsAvtiveBorder" : ""]' @click="menuGoType('step3')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-delive.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Delivery</a-row>
                            <a-row class="headerStepsTitle">Information</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col class="sbxs"  style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs"  :class='[isview=="step4" ? "stepsAvtiveBorder" : ""]' @click="menuGoType('step4')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-ship.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Shipment</a-row>
                            <a-row class="headerStepsTitle">Instruction</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col class="sbxs"  style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs" :class='[isview=="step5" ? "stepsAvtiveBorder" : ""]' @click="menuGoType('step5')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-orderSum.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Order</a-row>
                            <a-row class="headerStepsTitle">Summary</a-row>
                        </a-col>
                    </a-row>
                </a-col>

            </a-row>
            <keep-alive include="step1,step2,step3,step4,step5">
                <component :ref="'ref'+isview" :is="isview" v-on:setInitCloseValue="setInitCloseValue"   v-on:setIsview="setIsview"   v-on:goType="getGoType" v-on:emitValue="getValue" :sellLiquor="sellLiquor" v-on:goClose="getGoClose" :initCloseValue="initCloseValue" :stepSelectData="stepSelectData" ></component>
            </keep-alive>

            <!--关闭页面的弹出窗口-->
            <confirm3Button ref="confirm3Button" @closeWindowBack="closeWindowBack"></confirm3Button>

        </a-drawer>
    </div>
</template>
<script>
    import step1 from './coms/step1.vue'
    import step2 from './coms/step2.vue'
    import step3 from './coms/step3.vue'
    import step4 from './coms/step4.vue'
    import step5 from './coms/step5.vue'
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from "moment";
    import confirm3Button from "../components/confirm3Button";
    export default{
        components:{
            step1,
            step2,
            step3,
            step4,
            step5,
            confirm3Button,
        },
        data(){
            return{
                isview: 'step1',
                visible: false,
                sellLiquor:{},
                initCloseValue: undefined,
                stepSelectData: {}, // 下拉请求数据
                drawerTitle: 'Order Creation - Step1',
            }
          
        },
        watch:{
            isview(val){
                if(val == 'step1'){
                    this.drawerTitle = 'Order Creation - Step1'
                }else if(val == 'step2'){
                    this.drawerTitle = 'Order Creation - Step2'
                }else if(val == 'step3'){
                    this.drawerTitle = 'Order Creation - Step3'
                }else if(val == 'step4'){
                    this.drawerTitle = 'Order Creation - Step4'
                }else if(val == 'step5'){
                    this.drawerTitle = 'Order Creation - Step5'
                }
                // this.findTempSoValAjax()
            }
        },
        methods:{
            moment,
            show(){
                ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res=>{
                    if(res.data.currentStep == null || res.data.currentStep == '1' ){
                        this.isview = "step1"
                        this.initCloseValue = {}
                        if(res.data.currentStep == null){
                            this.initCloseValue.invTempDetailList = []
                        }else{
                            this.initCloseValue.invTempDetailList = res.data.invTempDetailList
                        }
                    }else{
                        this.initCloseValue = res.data
                        this.isview = "step" + this.initCloseValue.currentStep
                    }

                    let arr = this.initCloseValue.invTempDetailList
                    if(arr.length > 0 ){
                        for(let i in arr){
                            arr[i].receiveDate = moment(arr[i].receiveDate).format("YYYY-MM-DD");
                            if(arr[i].orderQty > 10){
                                arr[i].orderQtyFlag = false
                            }else{
                                arr[i].orderQtyFlag = true
                            }
                        }
                        this.initCloseValue.invTempDetailList = arr
                    }
                })
                this.visible = true
                if(this.isview == 'step1'){
                    this.drawerTitle = 'Order Creation - Step1'
                }else if(this.isview == 'step2'){
                    this.drawerTitle = 'Order Creation - Step2'
                }else if(this.isview == 'step3'){
                    this.drawerTitle = 'Order Creation - Step3'
                }else if(this.isview == 'step4'){
                    this.drawerTitle = 'Order Creation - Step4'
                }else if(this.isview == 'step5'){
                    this.drawerTitle = 'Order Creation - Step5'
                }


//                下拉数据
                ajax.post(api.INVWINEDROPDOWN,{code: 'SO_ORDERTYPE'}).then(res=>{
                    this.stepSelectData.orderType =  res.data
                })
                ajax.post(api.INVWINEDROPDOWN,{code: 'DELIVERY_MODE'}).then(res=>{
                    this.stepSelectData.deliveeryMode =  res.data
                })
                ajax.post(api.INVWINECOURRIER).then(res=>{
                    this.stepSelectData.courrierData =  res.data
                })
                ajax.post(api.INVWINEDROPDOWN,{code: 'ITEM_REMARK'}).then(res=>{
                    this.stepSelectData.itemRemarkData = res.data
                })
                ajax.post(api.INVWINEDROPDOWN,{code: 'TMS_DISTRICT'}).then(res=>{
                    this.stepSelectData.tmsDistrict = res.data
                })


            },
            findTempSoValAjax(){
            //   if(this.initCloseValue == undefined  && (this.isview != 'step3' && this.isview != 'step4' && this.isview != 'step5')){
                ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res=>{
                    let arr = res.data.invTempDetailList
                    if(arr != null || (arr != undefined && arr.length > 0)){
                        for(let i in arr){
                            arr[i].receiveDate = moment(arr[i].receiveDate).format("YYYY-MM-DD");
                            if(arr[i].orderQty > 10){
                                arr[i].orderQtyFlag = false
                            }else{
                                arr[i].orderQtyFlag = true
                            }
                        }
                    }
                    this.initCloseValue = res.data
                })
                // }
            },
            findTempSoValAjax2(val){
               
                ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res=>{
                    let arr = res.data.invTempDetailList
                    if(arr != null || (arr != undefined && arr.length > 0)){
                        for(let i in arr){
                            arr[i].receiveDate = moment(arr[i].receiveDate).format("YYYY-MM-DD");
                            if(arr[i].orderQty > 10){
                                arr[i].orderQtyFlag = false
                            }else{
                                arr[i].orderQtyFlag = true
                            }
                        }
                    }
                    this.initCloseValue = res.data

                    this.isview = val
                })
                
               
            },
            setInitCloseValue(val){
                this.initCloseValue = val;
            },
            setIsview(val){
                this.isview = val
            },
            getGoType(val){
                // step2 清空 step1 清空购物车
                // this.findTempSoValAjax()
                if(val == 'step2ResetBack'){
                 this.findTempSoValAjax()
                    this.isview = "step1"
                }

                if(val == 'step1'){
                    this.findTempSoValAjax()
                    this.isview = "step1"
                }

                if(val == 'close'){
                      this.findTempSoValAjax()
//                    this.initCloseValue = {}
                    this.sellLiquor = {}
                    this.visible = false
                    this.$emit('refreshSo')//关闭窗口后,刷新父组件SO列表数据
                }

                if(val == 'Next'){
                    // this.findTempSoValAjax()
                    this.nextClick()
                }

                if(val == 'Back'){
                      this.findTempSoValAjax()
                    this.goBack()
                }
              
                if("step5" == val){ // 特别处理step 5 先加载数据再加载页面
                     this.findTempSoValAjax2(val)
                }else if("step4" == val || "step3" == val ||"step2" == val){
                     this.findTempSoValAjax()
                    this.isview = val
                }
            },
            getValue(obj){
                if(obj.type == 'step1'){
                    this.sellLiquor.step1 = obj.data
                }else if(obj.type == 'step2'){
                    this.sellLiquor.step2 = obj.data
                }else if(obj.type == 'step3'){
                    this.sellLiquor.step3 = obj.data
                }else if(obj.type == 'step4'){
                    this.sellLiquor.step4 = obj.data
                }
            },
            nextClick(){
                if(this.isview == "step1"){
                    this.findTempSoValAjax()
                    this.isview = "step2"
                }else if(this.isview == "step2"){
                    this.findTempSoValAjax()
                    this.isview = "step3"
                    //   this.findTempSoValAjax2("step3")
                }else if( this.isview == "step3"){
                    // this.findTempSoValAjax2("step4")
                     this.findTempSoValAjax()
                    this.isview = "step4"
                }else if( this.isview == "step4"){
                     this.findTempSoValAjax2("step5")
                    // this.isview = "step5"
                }
            },
            goBack(){
                if(this.isview == "step2"){
                    this.isview = "step1"
                }else if(this.isview == "step3"){
                    this.isview = "step2"
                }else if(this.isview == "step4"){
                    this.isview = "step3"
                }else if(this.isview == "step5"){
                    this.isview = "step4"
                }
            },
            menuGoType(type){
                if(this.isview == "step3"){
                    this.$refs.refstep3.goTypeClick(type); // 切换的时候调保存
                    //  console.info("aaa   "+that.$refs.refstep3.test)
                }else
                if(this.isview == "step4"){
                    this.$refs.refstep4.goTypeClick(type);
                }else {
                    this.findTempSoValAjax()
                    this.isview = type
                }
            },
            getGoClose(){
                this.visible = false
                this.initCloseValue = {}
            },
            closeDrawer(){
                // let that = this
                // this.$confirm({
                //     title: 'Do you want to save before leave this step?',
                //     okText: 'Yes',
                //     okType: 'danger',
                //     cancelText: 'No',
                //     onOk() {
                //         if(that.$refs.refstep3 != undefined){
                //           that.$refs.refstep3.saveStep3()
                //         }
                //         if(that.$refs.refstep4 != undefined){
                //             that.$refs.refstep4.saveStep4()
                //         }
                //         that.visible = false
                //     },
                //     onCancel() {
                //         ajax.post(api.INVWINECLEARTEMP).then(res=>{})
                //         that.visible = false
                //     }
                // });
                let params = {
                    // title:'标题',
                    width:'500px',
                    content:'Do you want to save before leave this step?',
                    leftBtnName:this.$t('publicLang.Cancel'),
                    centerBtnName:this.$t('publicLang.No'),
                    rightBtnName:this.$t('publicLang.Yes'),
                }
                this.$refs.confirm3Button.show(params)
            },
            closeWindowBack(val){
                if(val == 2){
                    ajax.post(api.INVWINECLEARTEMP).then(res=>{})
                    this.visible = false
                }else if(val == 3){
                    if(this.$refs.refstep3 != undefined){
                        this.$refs.refstep3.saveStep3()
                        }
                        if(this.$refs.refstep4 != undefined){
                            this.$refs.refstep4.saveStep4()
                        }
                    this.visible = false
                }
            },
        }
    }
</script>
<style lang="less">
    .liquorDrawerLeft>.ant-drawer-content-wrapper{
        left:50%;
        margin-left: -590px;
    }
    .ant-drawer-header{
        padding: 16px;
    }
    .headerSteps{
        border-bottom: 1px solid #b7b7b7;
        color: #707070;
        padding-left: 16px;
        .stepsAvtiveBorder{
            padding:0 4px;
            border-bottom: 2px solid #3b62c2;
            font-weight: 800;
            color: #3b62c2;
        }
        .headerStepsTitle{
            font-size: 12px;
            line-height: 17px;
        }
    }
</style>